// extracted by mini-css-extract-plugin
export default {"productList":"ProductList_productList__AD+L9","productItem":"ProductList_productItem__xZdLl","deleteButton":"ProductList_deleteButton__eJP6n"};